import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgChartsLoader = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 100 100",
	enableBackground: "new 0 0 100 100",
	xmlSpace: "preserve",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			fill: "#1377E7",
			width: 3,
			height: 100,
			transform: "translate(0) rotate(180 3 50)",
			children: /* @__PURE__ */ _jsx("animate", {
				attributeName: "height",
				attributeType: "XML",
				dur: "1s",
				values: "30; 100; 30",
				repeatCount: "indefinite"
			})
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 17,
			fill: "#1377E7",
			width: 3,
			height: 100,
			transform: "translate(0) rotate(180 20 50)",
			children: /* @__PURE__ */ _jsx("animate", {
				attributeName: "height",
				attributeType: "XML",
				dur: "1s",
				values: "30; 100; 30",
				repeatCount: "indefinite",
				begin: "0.1s"
			})
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 40,
			fill: "#1377E7",
			width: 3,
			height: 100,
			transform: "translate(0) rotate(180 40 50)",
			children: /* @__PURE__ */ _jsx("animate", {
				attributeName: "height",
				attributeType: "XML",
				dur: "1s",
				values: "30; 100; 30",
				repeatCount: "indefinite",
				begin: "0.3s"
			})
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 60,
			fill: "#1377E7",
			width: 3,
			height: 100,
			transform: "translate(0) rotate(180 58 50)",
			children: /* @__PURE__ */ _jsx("animate", {
				attributeName: "height",
				attributeType: "XML",
				dur: "1s",
				values: "30; 100; 30",
				repeatCount: "indefinite",
				begin: "0.5s"
			})
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 80,
			fill: "#1377E7",
			width: 3,
			height: 100,
			transform: "translate(0) rotate(180 76 50)",
			children: /* @__PURE__ */ _jsx("animate", {
				attributeName: "height",
				attributeType: "XML",
				dur: "1s",
				values: "30; 100; 30",
				repeatCount: "indefinite",
				begin: "0.1s"
			})
		})
	]
});
export default SvgChartsLoader;
